// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnDailyContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btnDailyMailing {
  margin: 1rem;
}

.btnDailyMailing:hover {
  color: red;
}

button.btnDailyMailing {
  border: none;
  background-color: transparent;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Permalink.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":[".btnDailyContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.btnDailyMailing {\n  margin: 1rem;\n}\n\n.btnDailyMailing:hover {\n  color: red;\n}\n\nbutton.btnDailyMailing {\n  border: none;\n  background-color: transparent;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
